export default __webpack_public_path__ + "static/media/logout.b365c983.svg";